import React from 'react';

import { Alert, Container } from '@mui/material';

import PageSubheader from '~/components/Common/Elements/PageSubheader';
import PermissionedComponent from '~/components/Common/PermissionedComponent';

import { ROLE_ADMIN_USER, ROLE_GOOGLE_ADS_ADMIN } from '~/consts/roles';

import TaxEstimationPanel from './TaxEstimationPanel';

export default function TaxEstimationPage() {
  return (
    <Container maxWidth="xl">
      <PageSubheader title="Government tax estimates" />
      <PermissionedComponent
        requiredRoles={[ROLE_ADMIN_USER, ROLE_GOOGLE_ADS_ADMIN]}
        fallback={<Alert severity="warning">You are not authorised to view tax estimates.</Alert>}
      >
        <TaxEstimationPanel />
      </PermissionedComponent>
    </Container>
  );
}
